
const apiLangList = {
  "af": true,
  "sq": true,
  "sm": true,
  "az": true,
  "eu": true,
  "be": true,
  "bn": true,
  "bh": true,
  "bs": true,
  "bg": true,
  "ca": true,
  "hr": true,
  "cs": true,
  "da": true,
  "nl": true,
  "en": true,
  "eo": true,
  "et": true,
  "fo": true,
  "fi": true,
  "fr": true,
  "fy": true,
  "gl": true,
  "ka": true,
  "de": true,
  "el": true,
  "iw": true,
  "hi": true,
  "hu": true,
  "is": true,
  "id": true,
  "ia": true,
  "ga": true,
  "it": true,
  "ja": true,
  "jw": true,
  "kn": true,
  "ko": true,
  "la": true,
  "lv": true,
  "lt": true,
  "mk": true,
  "ms": true,
  "ml": true,
  "mt": true,
  "mr": true,
  "ne": true,
  "no": true,
  "nn": true,
  "oc": true,
  "fa": true,
  "pl": true,
  "pt-BR": true,
  "pt-PT": true,
  "pa": true,
  "ro": true,
  "ru": true,
  "gd": true,
  "sr": true,
  "si": true,
  "sk": true,
  "sl": true,
  "es": true,
  "su": true,
  "sw": true,
  "sv": true,
  "tl": true,
  "ta": true,
  "te": true,
  "th": true,
  "ti": true,
  "tr": true,
  "uk": true,
  "ur": true,
  "uz": true,
  "vi": true,
  "cy": true,
  "xh": true,
  "zu": true
}


const getApiLanguageMatchWithNavigator = (defaultLang = "en") => {
  // return english as default if is not possible to get the self. language
  if (!navigator) return defaultLang
  // makes a retry looking in all languages in the browser
  const matchedLanguaged = navigator.languages.find(language => {
    if (apiLangList[language]) return language
  })
  if (matchedLanguaged) return matchedLanguaged
  // if the search does not successeds, then return english
  return "en"
}

export { getApiLanguageMatchWithNavigator }
export default apiLangList
